import {BaseServiceClass} from "base-service-class";
import httpClient, {ApiResponseWrapper} from "http-client";
import {CreateSupportingDocument, GetListRequest, SupportingDocument, UpdateSupportingDocument} from "./models";

export default class SupportingDocumentApi extends BaseServiceClass {
    static getList(args: GetListRequest, token: string) {
        return httpClient.get<ApiResponseWrapper<SupportingDocument[]>>(`${this.BASE_URL}${this.PATH_MASTER.supporting_document}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                skip: args.skip,
                take: args.take
            }
        }).then((res) => res.data);
    }

    static getSingle(id: string, token: string) {
        return httpClient.get<ApiResponseWrapper<SupportingDocument>>(`${this.BASE_URL}${this.PATH_MASTER.supporting_document}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                id: id,
                skip: 0,
                take: 1
            }
        }).then((res) => res.data);
    }

    static createSupportingDocument(args: CreateSupportingDocument, token: string) {
        return httpClient.post<ApiResponseWrapper<null>>(`${this.BASE_URL}${this.PATH_MASTER.supporting_document}`, args, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        }).then((res) => res.data);
    }

    static updateSupportingDocument(args: UpdateSupportingDocument, token: string) {
        return httpClient.put<ApiResponseWrapper<null>>(`${this.BASE_URL}${this.PATH_MASTER.supporting_document}`, args, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        }).then((res) => res.data);
    }

    static deleteSupportingDocument(id: string, token: string) {
        return httpClient.delete<ApiResponseWrapper<null>>(`${this.BASE_URL}${this.PATH_MASTER.supporting_document}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                id: id
            }
        }).then((res) => res.data);
    }
}